export enum ConsumptionCalculationBase {
    STATIC = 'STATIC',
    DYNAMIC = 'DYNAMIC',
}
